import {Component} from "../../../gvf/js/component";

export class Cookies extends Component{
    create(name,value,days){
        let expires = "";
        if(days){
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 *  60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; patch=/";
    }

    read(name){
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i< ca.length; i++){
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    erase(name){
        this.create(name, "", -1);
    }

    ready(){
        const cookieN = "cookiesok";
        const cookieV = "ok";
        let cookie = this.read(cookieN);
        this.$root.toggle(cookie!=cookieV);

        this.findMember("close").click(
            (ev)=>{
                ev.preventDefault();
                this.create(cookieN, cookieV, 365);
                this.$root.remove();
            }
        );

        this.findMember("accept-all").click(
            (ev)=>{
                ev.preventDefault();
                this.create(cookieN, cookieV, 365);
                this.$root.css("display","none");
            }
        );

        this.$root.find("[href^=\"#popup\"]").click(
            (ev)=>{
                ev.preventDefault();
                let href = $(ev.currentTarget).attr("href");
                let $popup = $(href);
                $popup.fadeIn();
                $popup.find(".js-popup__close").click(
                    (ev)=>{
                        ev.preventDefault();
                        $popup.fadeOut();
                        this.create(cookieN, cookieV, 365);
                        this.$root.css("display","none");
                    }
                );
            }
        );
    }
}